import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useCompanyList() {
  // Use toast
  const toast = useToast()

  const refBundleListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'Name', label: 'Pachetto assicurativo', sortable: true },
    { key: 'product.Name', label: 'Prodotto', sortable: true },
    { key: 'product.company.company', label: 'Compangia', sortable: true },
    { key: 'IsEnabled', label: 'Attivo', sortable: true },
    { key: 'actions', label: 'Azioni' },
  ]
  const perPage = ref(50)
  const totalBundles = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('Name')
  const isSortDirDesc = ref(false)

  const dataMeta = computed(() => {
    const localItemsCount = refBundleListTable.value ? refBundleListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalBundles.value,
    }
  })

  const refetchData = () => {
    refBundleListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery], () => {
    refetchData()
  })

  const fetchBundles = (ctx, callback) => {
    store
      .dispatch('app-product/fetchPackages', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
      })
      .then(response => {
        const { bundles, total } = response.data
        callback(bundles)
        totalBundles.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Error fetching companies' list",
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }


  return {
    fetchBundles,
    tableColumns,
    perPage,
    currentPage,
    totalBundles,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refBundleListTable,

    refetchData,
  }
}
